import done from '../../assets/Done2.png'
const Img = () => {
    return ( 
        <div className="img">
            <img src={done} alt="me" />
        </div>
     );
}
 
export default Img;